import request from "../../../../utils/api";

let url = 'customers';

export const getCustomerFeedback = body => request(`${url}/${body}/feedbacks`);
export const postCustomerFeedback = body => request(`feedbacks`, { method: 'post', body });
export const putReadFeedback = body => request(`feedbacks/${body}/customer_read`, { method: 'put', body });
